import React, {FC} from 'react';
import styled from 'styled-components';

import {useLocalize} from '../../../../../../../libs/shared/core/src/helpers/internationalization/internationalizationContext';
import {Trans} from '../../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {boxedInputColorReaders} from '../../../../../../../libs/shared/ui/src/components/boxedInputs/boxedInputConstants';
import {DropdownBoxCoordinator} from '../../../../../../../libs/shared/ui/src/components/boxedInputs/dropdownBoxCoordinator';
import {Icon} from '../../../../../../../libs/shared/ui/src/components/icon/icon';
import {ContactModifiers} from '../../../../../../../srcCommon/inboxes/search/searchModifiersHelpers';
import type {SearchHintContactItemProps} from '../../../hints/searchHintContact/searchHintContact';
import {renderContactPillTitle} from '../../../hints/searchHintContact/searchHintContact';
import {SearchHintContactDropdown} from '../../../hints/searchHintContact/searchHintContactDropdown';

const StyledFlexDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const StyledPlaceholderSpan = styled.span`
  color: ${boxedInputColorReaders.textPlaceholder};
`;

/*
 * Props.
 */

export interface MultiSelectContactFieldProps extends Pick<SearchHintContactItemProps, 'selectedContacts'> {
  modifier: ContactModifiers;
  onChange: (arg: Array<string>) => void;
  onClear: () => void;
}

/*
 * Components.
 */

export const MultiSelectContactField: FC<MultiSelectContactFieldProps> = (props) => {
  const {modifier, selectedContacts, onChange, onClear} = props;
  const localize = useLocalize();

  const onClick = (handle: string) => {
    const selectedHandles = [...selectedContacts.map((e) => e.handle)];
    const index = selectedHandles.indexOf(handle);
    if (index > -1) {
      selectedHandles.splice(index, 1);
    } else {
      selectedHandles.push(handle);
    }
    onChange(selectedHandles);
  };

  return (
    <DropdownBoxCoordinator
      leftIcon={selectedContacts.length === 0 ? 'messageActivity' : undefined}
      value={
        selectedContacts.length > 0 ? (
          <StyledFlexDiv>
            <Icon name="messageActivity" />
            {renderContactPillTitle(selectedContacts, modifier, localize, {
              displayModifierName: false,
              valueTruncationLimit: 32,
            })}
          </StyledFlexDiv>
        ) : (
          <StyledPlaceholderSpan>
            <Trans id="search-query-builder-contact-placeholder">Enter email, contact, teammate</Trans>
          </StyledPlaceholderSpan>
        )
      }
      renderDropdown={(popoverProps) => (
        <SearchHintContactDropdown
          {...popoverProps}
          selectedContacts={selectedContacts}
          onClick={onClick}
          modifier={modifier}
          onClear={onClear}
          shouldHideHeaderTooltip
        />
      )}
      shouldDisablePadding
    />
  );
};
